import type { Comic, Category, Chapter } from './types';

export function getMockChapters(comicId: string): Chapter[] {
  const count = (parseInt(comicId.split('-')[1]) % 5) + 3;
  return Array.from({ length: count * 12 + (comicId.length % 10) }, (_, i) => ({
    id: `ch-${comicId}-${i + 1}`,
    comicId,
    title: i === 0 ? `第${i + 1}话` : `第${i + 1}话`,
    number: i + 1,
    updateTime: new Date(Date.now() - (count * 12 - i) * 86400000).toISOString().split('T')[0],
  }));
}

export const categories: Category[] = [
  { slug: 'romance', name: '恋爱', icon: 'ri-heart-line', count: 128 },
  { slug: 'fantasy', name: '奇幻', icon: 'ri-magic-line', count: 96 },
  { slug: 'action', name: '动作', icon: 'ri-sword-line', count: 87 },
  { slug: 'drama', name: '剧情', icon: 'ri-emotion-line', count: 74 },
  { slug: 'comedy', name: '搞笑', icon: 'ri-emotion-happy-line', count: 63 },
  { slug: 'thriller', name: '悬疑', icon: 'ri-search-eye-line', count: 52 },
  { slug: 'horror', name: '恐怖', icon: 'ri-ghost-line', count: 41 },
  { slug: 'slice-of-life', name: '日常', icon: 'ri-calendar-line', count: 38 },
  { slug: 'historical', name: '古风', icon: 'ri-ancient-gate-line', count: 29 },
  { slug: 'sci-fi', name: '科幻', icon: 'ri-rocket-line', count: 22 },
];

export const hotComics: Comic[] = [
  {
    id: 'comic-1',
    title: '我独自升级',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20art%2C%20solo%20leveling%20inspired%2C%20dark%20fantasy%20warrior%20with%20glowing%20eyes%2C%20dramatic%20lighting%2C%20cinematic%20composition%2C%20detailed%20character%20design%2C%20simple%20dark%20background%2C%20professional%20webtoon%20cover%20art&width=400&height=560&seq=comic-cover-01&orientation=portrait',
    author: 'Chugong / DUBU',
    category: 'fantasy',
    tags: ['奇幻', '战斗', '升级'],
    description: '十多年前，世界各地突然出现了连接异次元的"门"，而其中觉醒的人类被称为"猎人"。身为E级猎人的成振宇，在一次双重 dungeon 中濒临死亡，却意外获得了可以无限升级的"系统"...',
    updateTime: '2026-08-05',
    status: '连载中',
    rating: 9.8,
    views: 15800000,
    chapters: [],
  },
  {
    id: 'comic-2',
    title: '女神降临',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20beautiful%20girl%20with%20makeup%2C%20romance%20drama%2C%20soft%20pastel%20lighting%2C%20school%20life%20theme%2C%20elegant%20character%20design%2C%20simple%20light%20background%2C%20professional%20webtoon%20cover&width=400&height=560&seq=comic-cover-02&orientation=portrait',
    author: 'Yaongyi',
    category: 'romance',
    tags: ['恋爱', '校园', '成长'],
    description: '因为外貌被霸凌的任朱静，通过化妆技巧变成了校园女神。当她以为自己终于过上了完美的人生，两个性格截然不同的男生同时走进了她的生活...',
    updateTime: '2026-08-04',
    status: '连载中',
    rating: 9.5,
    views: 12300000,
    chapters: [],
  },
  {
    id: 'comic-3',
    title: '神之塔',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20mysterious%20tower%2C%20fantasy%20adventure%2C%20boy%20climbing%20massive%20structure%2C%20epic%20scale%2C%20dramatic%20cinematic%20lighting%2C%20simple%20dark%20background%2C%20professional%20webtoon%20cover%20art&width=400&height=560&seq=comic-cover-03&orientation=portrait',
    author: 'SIU',
    category: 'fantasy',
    tags: ['奇幻', '冒险', '战斗'],
    description: '第二十五夜为了追寻唯一的朋友蕾哈尔，进入了神秘的"塔"。塔的每一层都是一个世界，而只有登顶者才能实现任何愿望...',
    updateTime: '2026-08-05',
    status: '连载中',
    rating: 9.6,
    views: 14200000,
    chapters: [],
  },
  {
    id: 'comic-4',
    title: '看脸时代',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20dual%20personality%20character%2C%20handsome%20and%20ordinary%20contrast%2C%20school%20drama%2C%20action%20scenes%2C%20dramatic%20lighting%2C%20simple%20dark%20background%2C%20professional%20webtoon%20cover%20art&width=400&height=560&seq=comic-cover-04&orientation=portrait',
    author: '朴泰俊',
    category: 'drama',
    tags: ['剧情', '校园', '动作'],
    description: '因为外貌被欺负的朴亨硕，某天醒来发现自己可以切换成完美的外貌。从此，他的人生发生了天翻地覆的变化...',
    updateTime: '2026-08-03',
    status: '连载中',
    rating: 9.3,
    views: 11600000,
    chapters: [],
  },
  {
    id: 'comic-5',
    title: '全知读者视角',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20apocalyptic%20fantasy%2C%20protagonist%20with%20book%20knowledge%2C%20dramatic%20action%20pose%2C%20cinematic%20lighting%2C%20detailed%20character%20design%2C%20simple%20dark%20background%2C%20professional%20webtoon%20cover&width=400&height=560&seq=comic-cover-05&orientation=portrait',
    author: 'sing N song / Sleepy-C',
    category: 'fantasy',
    tags: ['奇幻', '末世', '策略'],
    description: '金独子是唯一读完了一部连载了十多年的网络小说的人。当小说中的世界突然变成现实，他凭借着对剧情的了解，开始了自己的生存之路...',
    updateTime: '2026-08-05',
    status: '连载中',
    rating: 9.7,
    views: 13500000,
    chapters: [],
  },
];

export const latestComics: Comic[] = [
  {
    id: 'comic-6',
    title: '甜蜜家园',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20horror%20apocalypse%2C%20monster%20transformation%2C%20survival%20theme%2C%20dark%20atmospheric%20lighting%2C%20intense%20character%20design%2C%20simple%20dark%20background%2C%20professional%20webtoon%20cover%20art&width=400&height=560&seq=comic-cover-06&orientation=portrait',
    author: '金坎比 / 黄英璨',
    category: 'horror',
    tags: ['恐怖', '末世', '生存'],
    description: '失去家人后陷入绝望的车贤秀搬进了一栋破旧的公寓，却发现世界正在被一种诡异的欲望怪物化现象吞噬...',
    updateTime: '2026-08-05',
    status: '已完结',
    rating: 9.4,
    views: 9800000,
    chapters: [],
  },
  {
    id: 'comic-7',
    title: '她的私生活',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20romance%20office%20lady%2C%20secret%20identity%2C%20warm%20lighting%2C%20elegant%20character%20design%2C%20romantic%20atmosphere%2C%20simple%20light%20background%2C%20professional%20webtoon%20cover%20art&width=400&height=560&seq=comic-cover-07&orientation=portrait',
    author: '金成妍',
    category: 'romance',
    tags: ['恋爱', '职场', '喜剧'],
    description: '成德美是美术馆的首席策展人，表面上是完美的职场女性，私下却是一个狂热的偶像粉丝。当她遇到新上任的馆长莱恩，一切都变得复杂起来...',
    updateTime: '2026-08-05',
    status: '已完结',
    rating: 9.1,
    views: 7600000,
    chapters: [],
  },
  {
    id: 'comic-8',
    title: '大贵族',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20vampire%20noble%2C%20elegant%20supernatural%20being%2C%20dark%20fantasy%2C%20gothic%20atmosphere%2C%20refined%20character%20design%2C%20simple%20dark%20background%2C%20professional%20webtoon%20cover%20art&width=400&height=560&seq=comic-cover-08&orientation=portrait',
    author: '孙齐皓 / 李光洙',
    category: 'fantasy',
    tags: ['奇幻', '吸血鬼', '战斗'],
    description: '贵族莱杰罗沉睡820年后在现代韩国醒来，作为掌控世界的暗影贵族，他发现自己忠实的仆人弗兰克斯坦已经为他建立了一所高中...',
    updateTime: '2026-08-04',
    status: '已完结',
    rating: 9.5,
    views: 11200000,
    chapters: [],
  },
  {
    id: 'comic-9',
    title: '心动警报',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20romance%20celebrity%20and%20doctor%2C%20contract%20relationship%2C%20warm%20romantic%20lighting%2C%20elegant%20characters%2C%20simple%20soft%20background%2C%20professional%20webtoon%20cover%20art&width=400&height=560&seq=comic-cover-09&orientation=portrait',
    author: '千桂英',
    category: 'romance',
    tags: ['恋爱', '明星', '契约'],
    description: '顶级女演员尹宥静因为一场绯闻事件，不得不与皮肤科医生车恩赫签订假恋爱契约。但这场戏假情真的游戏，却让两人的心越来越近...',
    updateTime: '2026-08-05',
    status: '连载中',
    rating: 9.0,
    views: 6800000,
    chapters: [],
  },
  {
    id: 'comic-10',
    title: '高校之神',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20martial%20arts%20tournament%2C%20high%20school%20fighter%2C%20intense%20action%20pose%2C%20dynamic%20lighting%2C%20simple%20dark%20background%2C%20professional%20webtoon%20cover%20art&width=400&height=560&seq=comic-cover-10&orientation=portrait',
    author: '朴容济',
    category: 'action',
    tags: ['动作', '格斗', '校园'],
    description: '全国高中生格斗大赛"高校之神"召开，来自全国各地的格斗高手齐聚一堂。高中生陈毛利凭借天赋异禀的格斗技巧，踏上了一条充满挑战的道路...',
    updateTime: '2026-08-03',
    status: '连载中',
    rating: 9.2,
    views: 8900000,
    chapters: [],
  },
  {
    id: 'comic-11',
    title: '解禁男女',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20office%20romance%2C%20unique%20relationship%2C%20mature%20theme%2C%20subtle%20warm%20lighting%2C%20elegant%20character%20design%2C%20simple%20soft%20background%2C%20professional%20webtoon%20cover&width=400&height=560&seq=comic-cover-11&orientation=portrait',
    author: 'Winter',
    category: 'romance',
    tags: ['恋爱', '职场', '治愈'],
    description: '郑智宥不小心被同事郑智厚发现了自己的秘密。两人的关系从秘密开始，逐渐发展成一段独特而深刻的情感羁绊...',
    updateTime: '2026-08-05',
    status: '已完结',
    rating: 9.3,
    views: 7200000,
    chapters: [],
  },
  {
    id: 'comic-12',
    title: '触不可及',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20fantasy%20romance%2C%20ghost%20and%20human%2C%20ethereal%20atmosphere%2C%20soft%20dreamy%20lighting%2C%20beautiful%20character%20design%2C%20simple%20light%20background%2C%20professional%20webtoon%20cover%20art&width=400&height=560&seq=comic-cover-12&orientation=portrait',
    author: 'Mago',
    category: 'fantasy',
    tags: ['奇幻', '恋爱', '治愈'],
    description: '能够看见鬼魂的女孩和无法被触碰的少年，两个孤独的灵魂在命运的安排下相遇。一段跨越生死的温暖故事就此展开...',
    updateTime: '2026-08-04',
    status: '连载中',
    rating: 9.1,
    views: 5400000,
    chapters: [],
  },
];

export const recommendedComics: Comic[] = [
  {
    id: 'comic-13',
    title: '狂王',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20epic%20historical%20warrior%2C%20ancient%20kingdom%2C%20battle%20scene%2C%20dramatic%20cinematic%20lighting%2C%20detailed%20armor%20design%2C%20simple%20dark%20background%2C%20professional%20webtoon%20cover&width=400&height=560&seq=comic-cover-13&orientation=portrait',
    author: '金镇奭 / 赵石',
    category: 'historical',
    tags: ['古风', '战争', '权谋'],
    description: '统一三国后，高句丽的建国神话在战场上被改写。一个狂放不羁的王者，一段波澜壮阔的史诗传奇...',
    updateTime: '2026-08-05',
    status: '连载中',
    rating: 9.6,
    views: 6700000,
    chapters: [],
  },
  {
    id: 'comic-14',
    title: '与神同行',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20afterlife%20underworld%2C%20grim%20reapers%2C%20fantasy%20drama%2C%20mystical%20atmosphere%2C%20detailed%20character%20design%2C%20simple%20dark%20background%2C%20professional%20webtoon%20cover%20art&width=400&height=560&seq=comic-cover-14&orientation=portrait',
    author: '周灏旻',
    category: 'drama',
    tags: ['剧情', '奇幻', '感动'],
    description: '人死后需要在49天内通过七重地狱的审判。消防员金自鸿在阴间使者的陪伴下，开启了一场关乎灵魂归宿的旅程...',
    updateTime: '2026-08-05',
    status: '已完结',
    rating: 9.7,
    views: 10500000,
    chapters: [],
  },
  {
    id: 'comic-15',
    title: '高斯电子',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20office%20comedy%2C%20tech%20company%20workers%2C%20humorous%20characters%2C%20bright%20cheerful%20lighting%2C%20simple%20light%20background%2C%20professional%20webtoon%20cover%20art&width=400&height=560&seq=comic-cover-15&orientation=portrait',
    author: '郭百洙',
    category: 'comedy',
    tags: ['搞笑', '职场', '日常'],
    description: '在高斯电子Marketing 3组，聚集了一群性格各异的职场人。他们用幽默和智慧对抗日常工作中的各种奇葩事件...',
    updateTime: '2026-08-04',
    status: '连载中',
    rating: 9.0,
    views: 5100000,
    chapters: [],
  },
];

export const bannerComics = [
  {
    id: 'banner-1',
    comicId: 'comic-1',
    title: '我独自升级',
    subtitle: '从最弱到最强的逆袭之路',
    description: 'E级猎人的成振宇在濒死之际获得神秘"系统"，开启无限升级之路。超人气韩漫，全网阅读量突破1500万！',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20epic%20fantasy%20art%2C%20solo%20warrior%20with%20glowing%20blue%20energy%2C%20dark%20dungeon%20background%20with%20magical%20portal%2C%20cinematic%20composition%2C%20dramatic%20atmospheric%20lighting%2C%20professional%20digital%20art%2C%20cool%20tone&width=1200&height=600&seq=banner-hero-01&orientation=landscape',
  },
  {
    id: 'banner-2',
    comicId: 'comic-5',
    title: '全知读者视角',
    subtitle: '当小说世界变成现实',
    description: '唯一读完连载十年的网络小说的金独子，在小说世界降临现实时，凭借对剧情的了解展开生存之旅！',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20apocalyptic%20fantasy%20art%2C%20protagonist%20reading%20book%20in%20destroyed%20city%2C%20dramatic%20contrast%20lighting%2C%20cinematic%20wide%20shot%2C%20professional%20digital%20art%2C%20warm%20and%20cool%20tone%20mix&width=1200&height=600&seq=banner-hero-02&orientation=landscape',
  },
  {
    id: 'banner-3',
    comicId: 'comic-8',
    title: '大贵族',
    subtitle: '沉睡820年的暗影贵族',
    description: '暗影贵族莱杰罗在现代韩国苏醒，忠仆弗兰克斯坦已为他准备好一切。经典韩漫神作，画风华丽！',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20gothic%20fantasy%20art%2C%20elegant%20vampire%20noble%20in%20modern%20city%2C%20dark%20gothic%20atmosphere%2C%20cinematic%20composition%2C%20dramatic%20moody%20lighting%2C%20professional%20digital%20art&width=1200&height=600&seq=banner-hero-03&orientation=landscape',
  },
];

export const allComics: Comic[] = [
  ...hotComics,
  ...latestComics,
  ...recommendedComics,
];